import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8540e462"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "hero",
  class: "d-flex align-items-center text-center text-white"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container content\" data-v-8540e462><h1 class=\"display-2\" data-v-8540e462> Transformiere Deine OKR-Erstellung mit unserem OKR-Checker </h1><p class=\"lead\" data-v-8540e462> Das Tool für effektive, zielorientierte und kollaborative Strategieplanung. </p><a href=\"login\" data-v-8540e462><button class=\"btn btn-lg\" data-v-8540e462> Starte jetzt die kostenlose Testphase </button></a></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}